export const notNull = (value: unknown): boolean => value !== null;
